import React from "react";
import { Navigate } from "react-router-dom";
import BulkSalesEditor from "../pages/Inventory Txn/Sales/BulkSalesEditor";
//Tables

import ReactTable from "../pages/Tables/ReactTables";

//QA Management
import DocumentContent from "../Components/QAManagementComponent/DocumentContent";
import HomePage from "../pages/QAManagement/HomePage";
import ModuleDetailPage from "../pages/QAManagement/ModuleDetailPage";
import ModuleList from "../pages/QAManagement/ProjectDetailPage";
import TestResult from "../pages/QAManagement/TestResult";
import UserManagement from "../pages/QAManagement/UserManagement";

//AuthenticationInner pages

//pages
import SimplePage from "../pages/Pages/Profile/SimplePage/SimplePage";
import Starter from "../pages/Pages/Starter/Starter";
import Timeline from "../pages/Pages/Timeline/Timeline";

import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import SearchResults from "../pages/Pages/SearchResults/SearchResults";
import SiteMap from "../pages/Pages/SiteMap/SiteMap";

//login
import ApiKey from "../pages/APIKey/index";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import Dummypage from "../pages/QAManagement/Dummypage";

//Inventory
//Product Categories
import PLList from "../pages/Inventory/ProductCategories/PLList";
import ProductCategoriesDisplay from "../pages/Inventory/ProductCategories/ProductCategoriesDisplay";
import ProductCategoriesEditor from "../pages/Inventory/ProductCategories/ProductCategoriesEditor";

//Customers
import SaleCustomersEditor from "../pages/Inventory/SaleCustomers/SaleCustomersEditor";
import SaleCustomersLists from "../pages/Inventory/SaleCustomers/SaleCustomersLists";
import SalesCustomersDisplay from "../pages/Inventory/SaleCustomers/SalesCustomersDisplay";
//Vendors
import VendorsDisplay from "../pages/Inventory/Vendors/VendorsDisplay";
import VendorsEditor from "../pages/Inventory/Vendors/VendorsEditor";
import VendorsList from "../pages/Inventory/Vendors/VendorsList";
//Sales
import SaleDisplay from "../pages/Inventory Txn/Sales/SaleDisplay";
import SaleEditor from "../pages/Inventory Txn/Sales/SaleEditor";
import SaleList from "../pages/Inventory Txn/Sales/SaleList";
//Purchases
import PurchaseDisplay from "../pages/Inventory Txn/Purchases/PurchaseDisplay";
import PurchaseEditor from "../pages/Inventory Txn/Purchases/PurchaseEditor";
import PurchaseList from "../pages/Inventory Txn/Purchases/PurchaseList";
//CustomerReport
import CustomerStatemenSummary from "../pages/InventoryReport/CustomerReport/CustomerStatemenSummary";
import CustomerStDetail from "../pages/InventoryReport/CustomerReport/CustomerStDetail";
//itemWTReport
import ProductItemwisetReport from "../pages/InventoryReport/InventoryIemReport/ProductItemwisetReport";
import TodaysItemTxnDetails from "../pages/InventoryReport/InventoryIemReport/TodaysItemTxnDetails";
//stocksummary_report
import StockSummaryReport from "../pages/InventoryReport/StockSummary/StockSummaryReport";
//VendorSummary
import VendorSDetail from "../pages/InventoryReport/VendorSummary/VendorSDetail";
import VendorSSummary from "../pages/InventoryReport/VendorSummary/VendorSSummary";
//Ssystem User
import SystemDisplay from "../pages/System Role/SystemDisplay";
import SystemEditor from "../pages/System Role/SystemEditor";
import SystemList from "../pages/System Role/SystemList";
//Management

import UserManageDisplay from "../pages/System Role/Usermanagement/UserManageDisplay";
import UserManageEditor from "../pages/System Role/Usermanagement/UserManageEditor";
import UserManageList from "../pages/System Role/Usermanagement/UserManageList";
//MenuInfo
import MenuInfoGetList from "../pages/System Role/MenuInfo/MenuInfoGetList";

import PostageDisplay from "../pages/Pages/Postage/PostageDisplay";
import PostageEditor from "../pages/Pages/Postage/PostageEditor";

//

import Fuellogbookreport from "../pages/InventoryReport/FuellogbookReport/Fuellogbookreport";
import Vvehiclelogbook from "../pages/InventoryReport/VehiclelogbookReport/Vvehiclelogbook";

import VendorwithTXNDetails from "../pages/Inventory/Vendors/VendorwithTXNDetails";
import AutoVoucher from "../pages/InventoryReport/AutoVoucher";
import InventoryDayBook from "../pages/InventoryReport/InventoryDayBook";

import ParcelMail from "../pages/System Role/ParcelMail";
import CustomerEditor from "../pages/CustomerType/CustomerEditor";
import CustomerViewDetail from "../pages/CustomerType/CustomerViewDetail";
import ServiceList from "../pages/Inventory/OneWorldServicing/ServiceList";
import ServiceEditor from "../pages/Inventory/OneWorldServicing/ServiceEditor";
import ServiceViewDetail from "../pages/Inventory/OneWorldServicing/ServiceViewDetail";
import PackageTypeGetList from "../pages/Inventory Txn/PaymentType/PackageTypeGetList";
import PackageTypeEditor from "../pages/Inventory Txn/PaymentType/PackageTypeEditor";
import PackagetTypeViewDetail from "../pages/Inventory Txn/PaymentType/PackagetTypeViewDetail";
import Goodcategorylist from "../pages/GoodCategory/Goodcategorylist";
import GoodcategoryEditor from "../pages/GoodCategory/GoodcategoryEditor";
import GoodcategoryViewDetail from "../pages/GoodCategory/GoodcategoryViewDetail";
import InsuranceGetList from "../pages/Insurance/InsuranceGetList";
import InsuranceEditor from "../pages/Insurance/InsuranceEditor";
import InsuranceViewDetail from "../pages/Insurance/InsuranceViewDetail";
import ConfigureSettingGetList from "../pages/Setting/ConfigureSettingGetList";
import ConfigureSettingUpdate from "../pages/Setting/ConfigureSettingUpdate";
import ConfigureSettingViewDeatail from "../pages/Setting/ConfigureSettingViewDeatail";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import PasswordChange from "../pages/Authentication/PasswordChange";
import InstructionList from "../pages/Instruction/InstructionList";
import InstructionEditor from "../pages/Instruction/InstructionEditor";
import InstructionViewDetail from "../pages/Instruction/InstructionViewDetail";

import EmailSettingGEtlist from "../pages/Setting/EmailSetting.js/EmailSettingGEtlist";

import EmailTemplategetlist from "../pages/Setting/Email Template/EmailTemplategetlist";
import EmailTemplateUpdate from "../pages/Setting/Email Template/EmailTemplateUpdate";
import ServiceSeting from "../pages/Setting/ServiceSettingg/ServiceSeting";
import ServiceSettingViewDetail from "../pages/Setting/ServiceSettingg/ServiceSettingViewDetail";
import ServicesettingvdEditor from "../pages/Setting/ServiceSettingg/ServicesettingvdEditor";
import ServicesettingAust from "../pages/Setting/ServiceSettingg/ServicesettingAust";
import Servicesettingcurriour from "../pages/Setting/ServiceSettingg/Servicesettingcurriour";
import AmazonSetttinglist from "../pages/Setting/Amazon S/AmazonSetttinglist";
import Emailtesting from "../pages/Setting/EmailSetting.js/Emailtesting";
import Registergetlist from "../pages/Authentication/Registergetlist";
import Rolesadminget from "../pages/Authentication/Rolesadminget";
import CurrencyGetlist from "../pages/Currecny/CurrencyGetlist";
import CurrencyEditor from "../pages/Currecny/CurrencyEditor";
import CurrencyViewDetail from "../pages/Currecny/CurrencyViewDetail";
import ImportReasonList from "../pages/ImportReason/ImportReasonList";
import ImportReasonEditor from "../pages/ImportReason/ImportReasonEditor";
import ImportReasonDisplay from "../pages/ImportReason/ImportReasonDisplay";
import DepoList from "../pages/Depos/DepoList";
import DepotEditor from "../pages/Depos/DepoEditor";
import DepotDetails from "../pages/Depos/DepoDetails";
import ShipmentReport from "../pages/Shipment Report/ShipmentReport";
import ShipmentDetail from "../pages/Shipment Report/ShipmentDetail";
import InvoiceGetlist from "../pages/InvoiceCrud/InvoiceGetlist";
import InvoiceUpdate from "../pages/InvoiceCrud/InvoiceUpdate";
import InvoiceViewDetails from "../pages/InvoiceCrud/InvoiceViewDetails";

import CustomerReport from "../pages/CustomerReport/CustomerReport";
import InvoiceReport from "../pages/Invoice Reports/InvoiceReport";
import Logger from "../pages/Logger/Logger";
import LogDetail from "../pages/Logger/LogDetail";

import AdminDocumentViewer from "../pages/DocumentViewer/AdminDocumentViewer";
import CustomerDocumentViewer from "../pages/DocumentViewer/CustomerDocumentViewer";
import Aapiloglist from "../pages/Setting/apilog/Aapiloglist";
import AapilogDetail from "../pages/Setting/apilog/AapilogDetail";
import Requestloglist from "../pages/Setting/Request log/Requestloglist";
import RequestlogDetail from "../pages/Setting/Request log/RequestlogDetail";
import RateCardEdit from "../pages/Pages/RateCard/RateCardEdit";
import InvoiceDetails from "../pages/Pages/InvoiceDetails/InvoiceDetails";
import DummyLabel from "../pages/Pages/Dummylabel";
import Dummy from "../pages/Pages/Dummylabel";
import ServiceExtra from "../pages/Setting/ServiceSettingg/ServiceExtra";
import ServiceExtraEditor from "../pages/Setting/ServiceSettingg/ServiceExtraEditor";
import EmailLogList from "../pages/Pages/EmailLog/EmailLogList";
import EmailLogDetail from "../pages/Pages/EmailLog/EmailLogDetail";
import IncomingApiLogList from "../pages/Setting/IncomingApiLog/IncomingApiLogList";
import IncomingApiLogDetail from "../pages/Setting/IncomingApiLog/IncomingApiLogDetail";
import ShipmentEdit from "../pages/ShipmentEdit/ShipmentEdit";

import Dashboard from "../OrderingSystem/Dashboard/Dashboard";

import PaymentReports from "../CosmosAdminPages/PaymentReports";
import TaxInvoices from "../CosmosAdminPages/TaxInvoices";

import Calender from "../CosmosAdminPages/Calendar";
import CustomerList from "../CosmosAdminPages/Customer/Pages/CustomerList";
import AppointmentList from "../CosmosAdminPages/Appointment/Pages/AppointmentList";
import Bookings from "../CosmosAdminPages/Booking/Pages/Bookings";
// import CustomerDetail from "../DibyaAdminPages/CustomerDetail/CustomerDetail";
import AppointmentDetail from "../CosmosAdminPages/Appointment/Pages/AppointmentDetail";
import Packages from "../CosmosAdminPages/PackagePage/Packages";
import PackageDetail from "../CosmosAdminPages/PackagePage/PackageDetail";
import UnavailbleTimeSlot from "../CosmosAdminPages/Unavailable TIme Slot/UnavailbleTimeSlot";
import UnavailbleTimeSlotList from "../CosmosAdminPages/Unavailable TIme Slot/UnavailableTimeSlotList";
import WeeklySchedule from "../CosmosAdminPages/Weekly Schedule/WeeklySchedule";
import OneTimeSchedule from "../CosmosAdminPages/One Time Schedule/OneTimeSchedule";
import ScheduleDetail from "../CosmosAdminPages/One Time Schedule/ScheduleDetail";
import DriverList from "../CosmosAdminPages/Drivers/DriverList";
import SettingPage from "../CosmosAdminPages/Settings/SettingPage";
import CustomerReports from "../CosmosAdminPages/Customer/Pages/CustomerReports";
import SMS from "../CosmosAdminPages/SMS/SMS";

import Suburb from "../CosmosAdminPages/Suburb/page/Suburb";
import DriverWeeklySchedule from "../CosmosAdminPages/Drivers/DriverWeeklySchedule";
import DriverWeeklyScheduleDetail from "../CosmosAdminPages/Drivers/Component/DriverWeeklyScheduleDetail";
import DriverAppointmentList from "../CosmosAdminPages/Appointment/Pages/DriverAppointmentList";
import DriverOneTimeSchedule from "../CosmosAdminPages/DriverOneTimeSchedule/DriverOneTimeSchedule";
import DriverDetails from "../CosmosAdminPages/Drivers/Component/DriverDetails";
import DriverCalender from "../CosmosAdminPages/CalendarDriver/page/DriverCalendar";
import CustomerDetailDriver from "../CosmosAdminPages/Customer/Component/CustomerDetailDriver";
import CountryPage from "../CosmosAdminPages/Country/page/CountryPage";
import CountryDetail from "../CosmosAdminPages/Country/page/CountryDetail";
import Mainpage from "../OrderingSystem/POS/page/Mainpage";
import PosLayout from "../OrderingSystem/POS/Layout/page/PosLayout";
import MenuItem from "../OrderingSystem/Menu/page/MenuItem";
import Waiter from "../OrderingSystem/Waiter/page/Waiter";
import Category from "../OrderingSystem/Category/page/Category";
import CategoryCreate from "../OrderingSystem/Category/component/CategoryCreate";
import Customers from "../OrderingSystem/Customer/page/Customers";
import ItemDetail from "../OrderingSystem/Menu/component/ItemDetail";
import CategoryDetail from "../OrderingSystem/Category/page/CategoryDetail";
import TableList from "../OrderingSystem/Table/page/TableList";
import CreateTable from "../OrderingSystem/Table/component/CreateTable";
import OrderList from "../OrderingSystem/Order/page/OrderList";
import OrderDetail from "../OrderingSystem/Order/page/OrderDetail";
import CustomerDetail from "../OrderingSystem/Customer/page/CustomerDetail";
import TenantOrganization from "../OrderingSystem/Tenant/TenantOrganization";
import Organization from "../OrderingSystem/Organization/page/Organization";
import TenantDetail from "../OrderingSystem/Tenant/component/TenantDetail";
import PaymentType from "../OrderingSystem/Payment Type/PaymentType";
import PaymentTypeDetail from "../OrderingSystem/Payment Type/PaymentTypeDetail";
import PaymentReport from "../OrderingSystem/PaymentReport/page/PaymentReport";
import PaymentDatBook from "../OrderingSystem/PaymentReport/page/PaymentDayBook";
import Section from "../OrderingSystem/Section/page/Section";
import DetailSection from "../OrderingSystem/Section/page/DetailSection";
import DetailTable from "../OrderingSystem/Table/page/DetailTable";
import Unit from "../OrderingSystem/Unit/page/Unit";
import CustomerType from "../OrderingSystem/CustomerType/page/CustomerType";
import ItemForm from "../OrderingSystem/Menu/component/ItemForm";
import CostCenter from "../OrderingSystem/CostCenter/page/CostCenter";
import SalesReport from "../OrderingSystem/SalesReport/page/SalesReport";
import ReturnBillLogs from "../OrderingSystem/SalesReport/page/ReturnBillLogs";
import GeneratePrintToken from "../OrderingSystem/GeneratePrintToken/page/GeneratePrintToken";
import CreditLog from "../OrderingSystem/PaymentReport/page/CreditLog";
import OrderDetailsList from "../OrderingSystem/Order/page/OrderDetailsList";
import ComplimentryLog from "../OrderingSystem/ComplimentryLogs/page/ComplimentryLog";
import DetailComplementry from "../OrderingSystem/ComplimentryLogs/component/DetailComplementry";
import Register from "../pages/Authentication/Register";
import SalesReportWise from "../OrderingSystem/SalesReport/page/SalesReportWise";
import CreditLogSummary from "../OrderingSystem/PaymentReport/page/CreditLogSummary";
import Purchase from "../OrderingSystem/Purchase/Purchase";
import PurchaseForm from "../OrderingSystem/Purchase/component/PurchaseForm";
import Supplier from "../OrderingSystem/Supplier/Supplier";
import SupplierForm from "../OrderingSystem/Supplier/component/SupplierForm";
import PurchaseDetail from "../OrderingSystem/Purchase/component/PurchaseDetail";
import OrgPage from "../OrderingSystem/QRMenu/OrgPage";
import LandingPage from "../OrderingSystem/Landing/page/LandingPage";
import DaybookOrderSummary from "../Daybook/page/DaybookOrderSummary";
import PaymentTypeSummary from "../Daybook/page/PaymentTypeSummary";
import RecipeList from "../OrderingSystem/RecipeManagement/page/RecipeList";
import RecipeForm from "../OrderingSystem/RecipeManagement/component/RecipeForm";
import ReceipeDetail from "../OrderingSystem/RecipeManagement/component/ReceipeDetail";
import UnitConversion from "../OrderingSystem/Unit/page/UnitConversion";
import DayBookLogs from "../OrderingSystem/PaymentReport/page/DayBookLogs";
import DaybookLogDetail from "../OrderingSystem/PaymentReport/component/DaybookLogDetail";
import ItemPercentDetailReport from "../OrderingSystem/SalesReport/component/ItemPercentDetailReport";
import TransactionReport from "../OrderingSystem/SalesReport/page/TransactionReport";

//ApprovedList

const authProtectedRoutes = [
  { path: "/home", component: <Navigate to="/project" /> },

  //Cosmos
  { path: "/payment-reports", component: <PaymentReports /> },
  { path: "/sms", component: <SMS /> },
  { path: "/unavailable-time-slot", component: <UnavailbleTimeSlot /> },
  {
    path: "/unavailable-time-slot-list",
    component: <UnavailbleTimeSlotList />,
  },
  { path: "/tax-invoices", component: <TaxInvoices /> },

  //Tables
  { path: "/tables-react", component: <ReactTable /> },

  { path: "/project/:id", component: <ModuleList /> },
  { path: "/project/module/testcase/:id", component: <TestResult /> },
  { path: "/project/module/:id", component: <ModuleDetailPage /> },
  { path: "/users", component: <UserManagement /> },
  { path: "/dashboard", component: <Dashboard /> },
  // { path: "/dashboard", component: <HomePage /> },
  { path: "/project/:id#pages/:docId", component: <DocumentContent /> },
  { path: "/dummytest", component: <Dummypage /> },
  // { path: "/test-hr-result", component: <TestHRResult /> },

  //Pages
  { path: "/pages-starter", component: <Starter /> },
  { path: "/pages-profile", component: <SimplePage /> },
  // { path: "/pages-profile-settings",component:<Setting/>, component: <Settings /> },
  { path: "/pages-timeline", component: <Timeline /> },

  { path: "/pages-sitemap", component: <SiteMap /> },
  { path: "/pages-search-results", component: <SearchResults /> },

  //Inventory
  //Product Categories
  { path: "/product-category", component: <PLList /> },
  {
    path: "/product-category/details/:id",
    component: <ProductCategoriesDisplay />,
  },
  { path: "/product-category/create", component: <ProductCategoriesEditor /> },
  {
    path: "/product-category/edit/:id",
    component: <ProductCategoriesEditor />,
  },

  //ProductUnits

  //Customers
  // { path: "/customers", component: <SaleCustomersLists /> },
  { path: "/customers/create", component: <SaleCustomersEditor /> },
  { path: "/customers/edit/:id", component: <SaleCustomersEditor /> },
  { path: "/customers/details/:id", component: <SalesCustomersDisplay /> },
  //CustomerType
  // { path: "/customer-type", component: <CustomerGetlist /> },
  { path: "/customer-type/create", component: <CustomerEditor /> },
  { path: "/customer-type/edit/:id", component: <CustomerEditor /> },
  { path: "/customer-type/details/:id", component: <CustomerViewDetail /> },

  //EmailSetting
  { path: "/email-setting", component: <EmailSettingGEtlist /> },

  //EmailTemplate
  { path: "/email-template", component: <EmailTemplategetlist /> },
  { path: "/email-template/edit/:key", component: <EmailTemplateUpdate /> },
  //Services
  { path: "/service-list", component: <ServiceList /> },
  { path: "/service-list/create", component: <ServiceEditor /> },
  { path: "/service-list/edit/:id", component: <ServiceEditor /> },
  { path: "/service-list/details/:id", component: <ServiceViewDetail /> },
  //Package Type
  { path: "/Package", component: <PackageTypeGetList /> },
  { path: "/Package/create", component: <PackageTypeEditor /> },
  { path: "/Package/edit/:id", component: <PackageTypeEditor /> },
  { path: "/Package/details/:id", component: <PackagetTypeViewDetail /> },
  //Good Categories
  { path: "/Categories", component: <Goodcategorylist /> },
  { path: "/Categories/create", component: <GoodcategoryEditor /> },
  { path: "/Categories/edit/:id", component: <GoodcategoryEditor /> },
  { path: "/Categories/details/:id", component: <GoodcategoryViewDetail /> },
  //Insurance
  { path: "/Insurance", component: <InsuranceGetList /> },
  { path: "/Insurance/create", component: <InsuranceEditor /> },
  { path: "/Insurance/edit/:id", component: <InsuranceEditor /> },
  { path: "/Insurance/details/:id", component: <InsuranceViewDetail /> },
  //Instruction
  { path: "/Instruction", component: <InstructionList /> },
  { path: "/Instruction/create", component: <InstructionEditor /> },
  { path: "/Instruction/edit/:id", component: <InstructionEditor /> },
  { path: "/Instruction/details/:id", component: <InstructionViewDetail /> },
  //Invoices
  { path: "/Invoice", component: <InvoiceGetlist /> },
  { path: "/Invoice/edit/:id", component: <InvoiceUpdate /> },
  { path: "/Invoice/details/:id", component: <InvoiceViewDetails /> },
  //Configure Setting
  { path: "/Configure Setting", component: <ConfigureSettingGetList /> },
  {
    path: "/Configure Setting/edit/:name",
    component: <ConfigureSettingUpdate />,
  },
  {
    path: "/Configure Setting/details/:name",
    component: <ConfigureSettingViewDeatail />,
  },
  //serviceSetting
  { path: "/service-setting", component: <ServiceSeting /> },
  {
    path: "/service-setting/details/Aramex",
    component: <ServiceSettingViewDetail />,
  },
  {
    path: "/service-setting/details/AusPost",
    component: <ServicesettingAust />,
  },
  {
    path: "/service-setting/details/Courier Please",
    component: <Servicesettingcurriour />,
  },

  { path: "/serviceextra-list/:id", component: <ServiceExtra /> },
  { path: "/serviceextra-list/edit/:id", component: <ServiceExtraEditor /> },
  //Currency
  { path: "/Currency", component: <CurrencyGetlist /> },
  { path: "/Currency/create", component: <CurrencyEditor /> },
  { path: "/Currency/edit/:id", component: <CurrencyEditor /> },
  { path: "/Currency/details/:id", component: <CurrencyViewDetail /> },

  //Outgoing Api log
  { path: "/api-log", component: <Aapiloglist /> },
  { path: "/api-log/:id", component: <AapilogDetail /> },

  //Incoming Api log
  { path: "/incoming-api-log", component: <IncomingApiLogList /> },
  { path: "/incoming-api-log/:id", component: <IncomingApiLogDetail /> },

  //Request log
  { path: "/request-log", component: <Requestloglist /> },
  { path: "/request-log/:id", component: <RequestlogDetail /> },

  //Email log
  { path: "/email-log", component: <EmailLogList /> },
  { path: "/email-log/:id", component: <EmailLogDetail /> },

  {
    path: "/service-setting/edit/:name",
    component: <ServicesettingvdEditor />,
  },
  //emailtest
  { path: "/EmailTest", component: <Emailtesting /> },

  //amazon
  { path: "/amazon-setting", component: <AmazonSetttinglist /> },
  {
    path: "/Service Setting/details/Aramex",
    component: <ServiceSettingViewDetail />,
  },

  //Vendors
  { path: "/vendor", component: <VendorsList /> },
  { path: "/vendor/create", component: <VendorsEditor /> },
  { path: "/vendor/edit/:id", component: <VendorsEditor /> },
  { path: "/vendor/details/:id", component: <VendorsDisplay /> },
  { path: "/vendor/viewdetails/:id", component: <VendorwithTXNDetails /> },
  //Sales
  { path: "/sales", component: <SaleList /> },
  { path: "/sales/create", component: <SaleEditor /> },
  { path: "/sales/edit/:id", component: <SaleEditor /> },
  { path: "/sales/details/:id", component: <SaleDisplay /> },
  //Bulk Sales
  { path: "/Bulk Sales", component: <BulkSalesEditor /> },
  //Purchase
  { path: "/purchases", component: <PurchaseList /> },
  { path: "/purchases/create", component: <PurchaseEditor /> },
  { path: "/purchases/edit/:id", component: <PurchaseEditor /> },
  { path: "/purchases/details/:id", component: <PurchaseDisplay /> },
  //CustomerReport
  { path: "/customer-summary", component: <CustomerStatemenSummary /> },
  { path: "/customer-summary/details/:id", component: <CustomerStDetail /> },
  //ItemWiseReport
  { path: "/itemwiseT_report", component: <ProductItemwisetReport /> },
  {
    path: "/itemwiseT_report/details/:id",
    component: <TodaysItemTxnDetails />,
  },
  //stocksummary
  { path: "/stocksummary_report", component: <StockSummaryReport /> },
  //vendosummary_report
  { path: "/vendosummary_report", component: <VendorSSummary /> },
  { path: "/vendosummary_report/details/:id", component: <VendorSDetail /> },
  //vehiclesummary_report
  // {path: "/vehicleLogBook_report", component:<VehiclelogBookList />},
  { path: "/vehicleLogBook_report", component: <Vvehiclelogbook /> },
  { path: "/vehicleLogBook_report", component: <Vvehiclelogbook /> },
  //Fuellogsummary_report
  // {path: "/vehicleLogBook_report", component:<VehiclelogBookList />},
  { path: "/fuelBook_report", component: <Fuellogbookreport /> },
  //
  { path: "/inventorydaybook-report", component: <InventoryDayBook /> },
  {
    path: "/inventorydaybook-report/:selectedDate",
    component: <AutoVoucher />,
  },

  //System User
  { path: "/system-user", component: <SystemList /> },
  { path: `/postage-display/:id1/:id2`, component: <ParcelMail /> },
  { path: "/system-user/create", component: <SystemEditor /> },
  { path: "/system-user/edit/:uuid", component: <SystemEditor /> },
  { path: "/system-user/details/:uuid", component: <SystemDisplay /> },
  //management
  { path: "/user-management", component: <UserManageList /> },
  { path: "/user-management/create", component: <UserManageEditor /> },
  { path: "/user-management/edit/:id", component: <UserManageEditor /> },
  { path: "/user-management/details/:uuid", component: <UserManageDisplay /> },

  //Import Reason
  { path: "/import-reason", component: <ImportReasonList /> },
  { path: "/import-reason/create", component: <ImportReasonEditor /> },
  { path: "/import-reason/edit/:id", component: <ImportReasonEditor /> },
  { path: "/import-reason/details/:id", component: <ImportReasonDisplay /> },

  //Logger
  { path: "/logger", component: <Logger /> },
  { path: "/logger/:id", component: <LogDetail /> },

  //Depot Office
  { path: "/depot-office", component: <DepoList /> },
  {
    path: "/depot-office/create",
    component: <DepotEditor />,
  },
  { path: "/depot-office/details/:id", component: <DepotDetails /> },
  { path: "/depot-office/edit/:id", component: <DepotEditor /> },

  //menuInfo
  { path: "/menu-Info", component: <MenuInfoGetList /> },

  //Postage
  { path: "/postage-form", component: <PostageEditor /> },
  {
    path: "/postage-form/:fromPostalCode/:toPostalCode",
    component: <PostageDisplay />,
  },

  //Postage
  { path: "/postage-form", component: <PostageEditor /> },
  //general report
  {
    path: "/postage-form/:fromPostalCode/:toPostalCode",
    component: <PostageDisplay />,
  },
  { path: "/dummy-label", component: <Dummy /> },

  //APIkey
  { path: "/apps-api-key", component: <ApiKey /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/Admin-roles", component: <Rolesadminget /> },
  { path: "/User-Role", component: <Registergetlist /> },
  { path: "/User-Role/create", component: <Register /> },
  { path: "/User-Role/edit/:id", component: <Register /> },
  // { path: "/Yup", component: <YupValidation /> },
  { path: "/change-password", component: <ChangePassword /> },
  { path: "/shipment-report", component: <ShipmentReport /> },
  { path: "/shipmentdetail/:id", component: <ShipmentDetail /> },
  { path: "/shipmentedit/:id", component: <ShipmentEdit /> },

  { path: "/invoice-report", component: <InvoiceReport /> },
  { path: "/invoice-report/detail/:id", component: <InvoiceDetails /> },

  { path: "/customer-report", component: <CustomerReport /> },

  // this route should be at the end of all other routesPaymentsReport
  { path: "/ratecard/edit/:id", component: <RateCardEdit /> },
  // { path: "*", component: <Navigate to="/auth-404-cover" /> },

  {
    path: "/admin-docs-viewer/:id",
    component: <AdminDocumentViewer />,
  },
  {
    path: "/customer-docs-viewer/:id",
    component: <CustomerDocumentViewer />,
  },

  // =============================== COSMOS ADMIN PAGES =====================================
  // customer list
  { path: "/customer", component: <CustomerList /> },
  // { path: "/customer/detail/:id", component: <CustomerDetails /> },

  //appointment list
  { path: "/appointment", component: <AppointmentList /> },
  { path: "/driver-appointment", component: <DriverAppointmentList /> },
  { path: "/appointment/detail/:id", component: <AppointmentDetail /> },

  //booking pages
  { path: "/bookings", component: <Bookings /> },
  { path: "/apps-calendar", component: <Calender /> },
  { path: "/driver/apps-calendar", component: <DriverCalender /> },
  // packages pages
  { path: "/packages", component: <Packages /> },
  { path: "/package/detail/:id", component: <PackageDetail /> },

  //schedule page
  { path: "/weekly-schedule", component: <WeeklySchedule /> },
  { path: "/one-time-schedule", component: <OneTimeSchedule /> },
  { path: "/one-time-schedule/detail/:id", component: <ScheduleDetail /> },
  { path: "/customer/detail/:id", component: <CustomerReports /> },
  { path: "/customer-detail/:id", component: <CustomerDetailDriver /> },
  { path: "/settings", component: <SettingPage /> },

  // driver page
  { path: "/drivers", component: <DriverList /> },
  { path: "/driver/detail/:id", component: <DriverDetails /> },
  { path: "/drivers/weekly-schedule", component: <DriverWeeklySchedule /> },
  {
    path: "/driver/weekly-schedule/:id",
    component: <DriverWeeklyScheduleDetail />,
  },
  { path: "/driver/one-time-schedule", component: <DriverOneTimeSchedule /> },
  { path: "/suburb", component: <Suburb /> },
  // {path:"/contact-us",component:<ContactUs/>}

  //country crud
  { path: "/country", component: <CountryPage /> },
  { path: "/country/detail/:id", component: <CountryDetail /> },

  // ==================================================
  // Ordering system
  { path: "/customer-list", component: <Customers /> },
  {
    path: "/customer/:id",
    component: <CustomerDetail />,
  },
  { path: "/staff", component: <Waiter /> },
  { path: "/category-list", component: <Category /> },
  {
    path: "/category/create",
    component: <CategoryCreate />,
  },
  {
    path: "/category/update/:id",
    component: <CategoryCreate />,
  },
  {
    path: "/category-detail/:id",
    component: <CategoryDetail />,
  },
  { path: "/menu-item", component: <MenuItem /> },
  { path: "/menu-item/create", component: <ItemForm /> },
  { path: "/menu-item/update/:id", component: <ItemForm /> },

  {
    path: "/item/detail/:id",
    component: <ItemDetail />,
  },
  { path: "/table", component: <TableList /> },
  { path: "/table/create", component: <CreateTable /> },
  { path: "/table/update/:id", component: <CreateTable /> },
  { path: "/table/detail/:id", component: <DetailTable /> },

  { path: "/order", component: <OrderList /> },
  { path: "/order-detail", component: <OrderDetailsList /> },
  {
    path: "/order/:id",
    component: <OrderDetail />,
  },

  { path: "/tenant", component: <TenantOrganization /> },
  { path: "/tenant/detail/:id", component: <TenantDetail /> },

  { path: "/organization", component: <Organization /> },
  // ================================================

  { path: "/pos", component: <PosLayout /> },
  { path: "/payment/statement", component: <PaymentReport /> },
  { path: "/day-book", component: <PaymentDatBook /> },

  // payment type page
  { path: "/payment-type", component: <PaymentType /> },
  { path: "/payment-type/detail/:id", component: <PaymentTypeDetail /> },

  { path: "/section", component: <Section /> },
  { path: "/section/detail/:id", component: <DetailSection /> },

  { path: "/unit", component: <Unit /> },
  { path: "/unit-conversion", component: <UnitConversion /> },
  { path: "/customer-type", component: <CustomerType /> },

  { path: "/cost-center", component: <CostCenter /> },
  { path: "/sales-report", component: <SalesReport /> },
  { path: "/sales-report/wise", component: <SalesReportWise /> },
  { path: "/transaction/report", component: <TransactionReport /> },
  { path: "/transaction/report/:id", component: <TransactionReport /> },

  { path: "/return-bill-report", component: <ReturnBillLogs /> },
  { path: "/generate-print-token", component: <GeneratePrintToken /> },

  { path: "/credit-logs/customer/:id", component: <CreditLog /> },
  { path: "/credit-logs/summary", component: <CreditLogSummary /> },

  { path: "/complimentry-logs", component: <ComplimentryLog /> },
  { path: "/complimentry-logs/detail/:id", component: <DetailComplementry /> },

  { path: "/purchase", component: <Purchase /> },
  { path: "/purchase/create", component: <PurchaseForm /> },
  { path: "/purchase/update/:id", component: <PurchaseForm /> },
  { path: "/purchase/detail/:id", component: <PurchaseDetail /> },

  { path: "/suppliers", component: <Supplier /> },
  { path: "/suppliers/create", component: <SupplierForm /> },
  { path: "/suppliers/update/:id", component: <SupplierForm /> },

  { path: "/dayclose/order-summary", component: <DaybookOrderSummary /> },
  { path: "/dayclose/payment-type-summary", component: <PaymentTypeSummary /> },

  // receipe management-----------------------------
  { path: "/receipe-management", component: <RecipeList /> },
  { path: "/receipe-management/create", component: <RecipeForm /> },
  { path: "/receipe-management/update/:id", component: <RecipeForm /> },
  { path: "/receipe/detail/:id", component: <ReceipeDetail /> },

  { path: "/logs/day-book", component: <DayBookLogs /> },
  { path: "/logs/day-book/:id", component: <DaybookLogDetail /> },

  { path: "/percent-wise-item/all/", component: <ItemPercentDetailReport /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/", component: <Login /> },

  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/org-register", component: <Register /> },

  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPassword /> },

  { path: "/forgot-password-change", component: <PasswordChange /> },

  //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  {
    path: "/:orgcode",
    component: <OrgPage />,
  },

  {
    path: "/:orgcode/:page",
    component: <OrgPage />,
  },
  {
    path: "/:orgcode/:page/:subPage",
    component: <OrgPage />,
  },
  {
    path: "*",
    component: <OrgPage />,
  },
];

export { authProtectedRoutes, publicRoutes };
